<template>
  <a-modal v-model:visible="modal.show" wrapClassName="modal_qr"
           :width="300" :footer="null" :closable="false" destroyOnClose>
    <img alt=""
         :src="file.ImageQR" />
    <a-typography-paragraph v-if="expand.current">
      微信扫码添加小助手<br>
      回复{{ expand.type[expand.current] }}即可
    </a-typography-paragraph>
  </a-modal>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';
import ImageQR from '@resource/image/public/qr_assistant.jpg';

export default {
  name: 'page_modalQR',
  data(): DataInterface {
    return {
      file: {
        ImageQR
      },
      modal: {
        show: false
      },
      expand: {
        current: '',
        type: {
          tryUse: '“试用”',
          openSource: '“开源”',
          cost: '“成本”',
          planName: '解决方案名称',
          fnKey: '功能关键词',
          cityAmbassador: '“城市大使”',
          communityWeek: '“社区周会”'
        }
      }
    };
  },
  methods: {
    /**
     * 打开
     * @param {string} type 类型
     */
    open(type: string): void {
      this.modal.show = true;
      this.expand.current = type;
    },
    
    /**
     * 关闭
     */
    close(): void {
      this.modal.show = false;
      this.expand.current = '';
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less">
@import '@resource/css/_global.less';

@image: '@{src_image}';

.modal_qr {
  .ant-modal {
    max-width: 90%;
    
    .ant-modal-body {
      padding: 15px 20px;
    }
  }
  
  .ant-typography {
    margin: 0;
    .font(center, @text_mo+@line_mo, @color_black, @text_mo);
  }
  
  img {
    display: block;
    width: 100%;
  }
}
</style>